import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getGames } from '../../../api/GamesAPI';
import AppBreadCrumb from '../../../components/common/AppBreadCrumb';
import AppPaginator from '../../../components/AppPaginator';
import AppSearchBox from '../../../components/AppSearchBox';
import PerPageBlock from '../../../components/common/PerPageBlock';

// --- A new component for the "Coming Soon" placeholder ---
const ComingSoonPlaceholder = () => {
    const placeholderStyle = {
        backgroundImage: `url('/assets/images/5.jpg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        borderRadius: '0.5rem',
        padding: '5rem 2rem',
        position: 'relative',
        color: '#fff',
        textAlign: 'center',
        overflow: 'hidden'
    };

    const overlayStyle = {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(15, 98, 106,1)',
        backdropFilter: 'blur(3px)'
    };

    const contentStyle = {
        position: 'relative',
        zIndex: 2
    };

    return (
        <div style={placeholderStyle}>
            <div style={overlayStyle}></div>
            <div style={contentStyle}>
                <h1 className="display-4 fw-bold">Will be available from Launch Day!</h1>
                <p className="lead">
                    The full Games, Live Scoring, and Scorecard feature  will be available from launch
                </p>
                <p>Stay tuned .</p>
                <i className="fas fa-trophy fa-3x mt-3 text-warning"></i>
            </div>
        </div>
    );
};


const GamesPage = () => {
    // --- Check the environment variable ---
    const gamesFeatureEnabled = process.env.REACT_APP_GAMES_FEATURE_ENABLED === 'true';

    const navigate = useNavigate();
    const [gamesList, setGamesList] = useState({ data: [], last_page: 0 });
    const [isLoading, setIsLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(15);
    const [searchTerm, setSearchTerm] = useState('');
    const [searchTermCompleted, setSearchTermCompleted] = useState('');

    useEffect(() => {
        // Only fetch data if the feature is enabled
        if (gamesFeatureEnabled) {
            setIsLoading(true);
            const filters = { page: currentPage, per_page: perPage, search_term: searchTermCompleted };
            getGames(filters, (response) => {
                setIsLoading(false);
                if (response.games) {
                    setGamesList(response.games);
                }
            });
        } else {
            setIsLoading(false);
        }
    }, [currentPage, perPage, searchTermCompleted, gamesFeatureEnabled]);

    const handleAddClick = () => navigate('/club_portal/games/create');
    const handleViewClick = (id) => navigate(`/club_portal/games/${id}`);

    return (
        <main>
            <div className="container-fluid">
                <AppBreadCrumb title="Games" />

                {/* --- Conditional Rendering Logic --- */}
                {!gamesFeatureEnabled ? (
                    <ComingSoonPlaceholder />
                ) : (
                    <>
                        <div className="tab-wrapper mb-3">
                            <ul className="tabs">
                                <li className="tab-link active">All Games</li>
                                <li className="ms-md-auto">
                                    <div className="text-md-end d-flex flex-column flex-md-row align-items-md-center">
                                        <AppSearchBox searchTerm={searchTerm} setSearchTerm={setSearchTerm} setSearchTermCompleted={setSearchTermCompleted} />
                                        <button className="btn btn-primary btn-sm mt-2 mt-md-0 ms-md-3" onClick={handleAddClick}>
                                            <i className="ti ti-plus f-s-18"></i> Schedule New Game
                                        </button>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div className="row">
                            {isLoading ? (
                                <div className="col-12 text-center"><div className="spinner-border"></div></div>
                            ) : gamesList.data.length > 0 ? (
                                gamesList.data.map(game => (
                                    <div className="col-md-6 col-lg-4" key={game.id}>
                                        <div className="card hover-effect">
                                            <div className="card-body">
                                                <div className="d-flex justify-content-between align-items-center mb-2">
                                                    <span className={`badge bg-light-${game.status === 'scheduled' ? 'primary' : 'success'}`}>{game.status}</span>
                                                    <small className="text-muted">{game.game_date}</small>
                                                </div>
                                                <h5 className="card-title text-center">
                                                    {game.teams.map(t => t.name).join(' vs ')}
                                                </h5>
                                                <p className="card-text text-center text-muted">
                                                    {game.venue.name} <br/>
                                                    {game.overs} Overs ({game.game_type})
                                                </p>
                                                <div className="text-center">
                                                    <button onClick={() => handleViewClick(game.id)} className="btn btn-outline-primary btn-sm">View Scorecard</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div className="col-12"><p>No games scheduled yet. Click "Schedule New Game" to get started.</p></div>
                            )}
                        </div>
                        {gamesList.data.length > 0 &&
                            <div className="d-flex justify-content-between align-items-center mt-3">
                                <AppPaginator totalPages={gamesList.last_page} currentPage={currentPage} setCurrentPage={setCurrentPage} />
                                <PerPageBlock perPage={perPage} setPerPage={setPerPage} />
                            </div>
                        }
                    </>
                )}
            </div>
        </main>
    );
};

export default GamesPage;